// extracted by mini-css-extract-plugin
module.exports = {"productWrapper":"styles_productWrapper__qcSV5","container":"styles_container__qB6_9"};